<template>
  <!-- Language Dropdown -->
  <ZSDropdown style="position: absolute;z-index: 50;" trigger-text=""  ref="languageDropdown" class="language-dropdown-login">
    <template #trigger="{ toggle }">
      <div class="language-trigger-login" @click="toggle">
        <span v-if="locale == 'pt'"><img alt="Português" class="flag" src="@/assets/portugal.png" /></span>
        <span v-if="locale == 'es'"><img alt="Español" class="flag" src="@/assets/spain.png" /></span>
        <span v-if="locale == 'en'"><img alt="English" class="flag" src="@/assets/united-kingdom.png" /></span>
        <span v-if="locale == 'fr'"><img alt="Francais" class="flag" src="@/assets/france-flag-icon.webp" /></span>
        <img src="@/assets/ChevronDown.svg" alt="Dropdown" class="chevron-icon">
      </div>
    </template>

    <div class="language-menu-login">
      <div class="menu-item lang-item" @click="changeLanguage('pt')">
        <img alt="Português" class="flag" src="@/assets/portugal.png" />
        <span>Português</span>
      </div>
      <div class="menu-item lang-item" @click="changeLanguage('es')">
        <img alt="Español" class="flag" src="@/assets/spain.png" />
        <span>Español</span>
      </div>
      <div class="menu-item lang-item" @click="changeLanguage('en')">
        <img alt="English" class="flag" src="@/assets/united-kingdom.png" />
        <span>English</span>
      </div>
      <div class="menu-item lang-item" @click="changeLanguage('fr')">
        <img alt="Francais" class="flag" src="@/assets/france-flag-icon.webp" />
        <span>Francais</span>
      </div>
    </div>
  </ZSDropdown>
  <div class="login-page" v-if="showLoginPage">
    <div class="main-section">
      <div class="banner">
        <!-- <img src="/src/assets/mock_images/photo1.jpeg"> -->
        <!-- <pre>{{ campaigns }}</pre> -->
  <SlideShow
    :slides="campaigns"
    transitionType="fade"
    :autoplay="true"
    :interval="5000"
    height="400px"
    :full-height="!isSmall"
    :showNavButtons="isSmall"
    :showIndicators="!isSmall"
  />
      </div>
      <div class="login-form" :class="{ 'change-password-form': state == CHANGE_PASSWORD_STATE }">
        <div class="logo">
          <img @click="stats_visible = !stats_visible" alt="ZSLIC logo" class="logo-img" src="@/assets/zslic_logo.svg" />
        </div>
        <div class="form-title">{{ titleLabel }}</div>

        <form @submit.prevent="doAction" autocomplete="on">
        <div class="field">
          <!-- <label for="login">{{ $t("login.login") }}</label> -->
          <input id="login" name="username" autocomplete="username" :placeholder=" $t('login.login') " type="text" v-model="login" @keyup.enter="doAction" />

        </div>
        <!--All passwords are identified by pass1, pass2, pass3-->
        <div v-if="state == CHANGE_PASSWORD_STATE || state == LOGIN_STATE" class="field">
          <!-- <label for="pass1">{{ loginPasswordLabel }}</label> -->
          <input id="pass1" name="password" :autocomplete="state === LOGIN_STATE ? 'current-password' : 'current-password'" :placeholder=" loginPasswordLabel " type="password" @keyup.enter="doAction" v-model="password" />
        </div>
        <div v-if="state == CHANGE_PASSWORD_STATE" class="field">
          <!-- <label for="pass2">{{ $t("login.new_password") }}</label> -->
          <input id="pass2" name="new-password" autocomplete="new-password" :placeholder=" $t('login.new_password') " type="password" @keyup.enter="doAction" v-model="newPassword1" />
        </div>
        <div v-if="state == CHANGE_PASSWORD_STATE" class="field">
          <!-- <label for="pass3">{{ $t("login.new_password_conf") }}</label> -->
          <input id="pass3" name="new-password-confirm" autocomplete="new-password" :placeholder=" $t('login.new_password_conf') " type="password" @keyup.enter="doAction" v-model="newPassword2" />
        </div>
        <div v-if="state == RECOVER_PASSWORD" class="field">
           <input id="email" name="email" autocomplete="email" :placeholder=" $t('login.email') " type="email" v-model="email"/>
        </div>
        <div class="field">
          <ZSButton type="submit" color="orange" style="width: 100%;font-weight: bold;font-size: 90%;justify-content: center;">{{ $t("login.submit") }}</ZSButton>
        </div>
        <div class="field links-container">
          <a v-if="state === LOGIN_STATE" @click="state = CHANGE_PASSWORD_STATE">{{ $t("login.change_password") }}</a>
          <a v-if="state === LOGIN_STATE" @click="state = RECOVER_PASSWORD">{{ $t("login.recover_password") }}</a>
          <a v-if="state === CHANGE_PASSWORD_STATE || state === RECOVER_PASSWORD" @click="state = LOGIN_STATE">{{ $t("login.cancel_change_password") }}</a>
        </div>
        </form>
        <div v-if="state === LOGIN_STATE" class="sso-section">
          <div class="sso-divider">
            <span>{{ $t("login.or") }}</span>
          </div>
          <!-- Google's officially rendered button. It lives in a cross-origin
               iframe, so the user must click it directly (no synthetic click). -->
          <div ref="googleSsoBtn" class="google-sso-btn"></div>
          <!-- <button class="sso-btn sso-microsoft" :disabled="ssoLoading" @click="doMicrosoftSSO">
            <img src="@/assets/microsoft-icon.svg" alt="Microsoft" class="sso-icon" />
            {{ $t("login.sso_microsoft") }}
          </button> -->
        </div>

        <div class="bottom-logo">
          <img src="@/assets/zslogo.png" alt="ZS Logo" />
        </div>
      </div>
    </div>
    <div :class="{ hidden: !stats_visible }" class="version-holder">
      v{{ appVersion }}<template v-if="serverVersion.app">/v{{ serverVersion.app }}</template>
    </div>
    <div :class="{ hidden: !stats_visible }" class="hash-holder">
      {{ appHash }}<template v-if="serverVersion.hash">/{{ serverVersion.hash }}</template>
    </div>
  </div>
</template>

<script setup>
// import ZSDropdown from '@/components/zs-components/ZSDropdown.vue'
import SlideShow from "../../components/SlideShow.vue";

import { useRouter } from "vue-router";

import { ref, computed, onMounted, onBeforeMount } from "vue";

import { useUserStore } from "../../stores/user";

import { useZSToast } from "@/components/zs-components/toast/useToast";
import { useAppVersion } from "@/use/appVersion";

import { useI18n } from "vue-i18n";

import {useAdvertisingStore} from "@/stores/advertising";
const advertisingStore = useAdvertisingStore();


import { useTagStore } from "@/stores/tag";
const tagStore = useTagStore();

import { useMicrosoftSSO } from "@/composables/useMicrosoftSSO";

import { useMediaQuery } from "@/use/media_query";
const { xs,sm, md } = useMediaQuery();

const isSmall = computed(() => {
  return xs.value || sm.value || md.value;
});


// Versões FE (.env + commit do build) e BE (via /v1/version), partilhadas com o sidenav.
const { appVersion, appHash, serverVersion, fetchServerVersion } = useAppVersion();

const campaigns = computed(() => {
  if(advertisingStore.campaigns.length > 0){
    return advertisingStore.campaigns
  } else return defaultSlide;
}
);

  const defaultSlide = [
        {
            "id": 1,
            "primary_title": "",
            "secondary_title": "ZoneSoft",
            "subtitle": "",
            "start_date": "2025-04-17 01:00:00",
            "end_date": "2025-04-25 12:00:00",
            "color": "#2980B9",
            "is_btn_active": 1,
            "btn_text": "",
            "btn_link": "https://www.zonesoft.pt/",
            "logo_image": "",
            "campaign_image": "/default_slide.png",
            "created_at": "2025-04-17 09:38:27",
            "updated_at": "2025-04-17 11:02:42"
        }
      ]

const LOGIN_STATE = "LOGIN_STATE";
const CHANGE_PASSWORD_STATE = "CHANGE_PASSWORD_STATE";
const RECOVER_PASSWORD = "RECOVER_PASSWORD";
const state = ref(LOGIN_STATE);

const { t, locale } = useI18n();

const toast = useZSToast();

const userStore = useUserStore();

const router = useRouter();

const name = ref("");
const login = ref(import.meta.env.VITE_LOGIN);
const password = ref(import.meta.env.VITE_PASSWORD);
const newPassword1 = ref("");
const newPassword2 = ref("");
const email = ref("");

const ssoLoading = ref(false);
const googleSsoBtn = ref(null);

const { loginWithMicrosoft } = useMicrosoftSSO();

const languageDropdown = ref();

const changeLanguage = (lang) => {
  locale.value = lang;
  localStorage.setItem("lang", lang);
  languageDropdown.value.closeDropdown();
  // Fetch não-crítico (há defaultSlide como fallback) — não deixar a rejeição flutuar.
  advertisingStore.fetchCampaigns(lang).catch((err) => console.error("fetchCampaigns failed", err));
};

const reset = () => {
  name.value = "";
  login.value = "";
  password.value = "";
  newPassword1.value = "";
  newPassword2.value = "";
};

const titleLabel = computed(() => {
  if (state.value === LOGIN_STATE)
    return t("login.title");
  else if (state.value === CHANGE_PASSWORD_STATE)
    return t("login.title_change_password");
  else if (state.value === RECOVER_PASSWORD)
    return t("login.title_recover_password");
});

const loginPasswordLabel = computed(() => {
  return state.value === LOGIN_STATE
    ? t("login.password")
    : t("login.old_password");
});

const doAction = () => {
  if (state.value === LOGIN_STATE) {
    doLogin();
  } else if (state.value === CHANGE_PASSWORD_STATE) {
    doChangePassword();
  } else if (state.value === RECOVER_PASSWORD) {
    doRecoverPassword();
  }
};

const doRecoverPassword = async () => {
  const data = {
    login: login.value,
    email: email.value,
  };

  try {
    await userStore.recoverPassword(data);
    toast.add({
      type: "success",
      summary: t("login.recover_password_success"),
      detail: t("login.password_recovered_text"),
      life: 6000,
    });
    state.value = LOGIN_STATE;
    reset();
  } catch (error) {
    toast.add({
      type: "error",
      summary: t("login.recover_password_error"),
      detail: t("login.check_recover_data_error"),
      life: 6000,
    });
  }
};

const doChangePassword = async () => {
  if (newPassword1.value !== newPassword2.value) {
    toast.add({
      type: "error",
      summary: t("login.change_password_error"),
      detail: t("login.passwords_dont_match"),
      position:'c',
      life: 6000,
    });
    return;
  }

  if (newPassword1.value.length < 5) {
    toast.add({
      type: "error",
      summary: t("login.change_password_error"),
      detail: t("login.password_too_short"),

      life: 6000,
    });
    return;
  }

  const data = {
    login: login.value,
    password: password.value,
    new_password: newPassword1.value,
  };

  try {
    await userStore.changePassword(data);
    toast.add({
      type: "success",
      summary: t("login.change_password_success"),
      detail: t("login.password_changed_text"),
      life: 6000,
    });
    state.value = LOGIN_STATE;
    reset();
  } catch (error) {
    console.log("CHANGE PASSWORD ERROR", error);
  }
};

const getSSOErrorMessage = (error) => {
  const code = error?.response?.data?.code;
  switch (code) {
    case "sso.no_account":
      return t("login.sso_no_account");
    case "login.blocked":
      return t("login.sso_user_blocked");
    default:
      return t("login.sso_error_generic");
  }
};

let googleSsoInit = null;

const waitForGoogle = () =>
  new Promise((resolve) => {
    if (window.google?.accounts?.id) return resolve();
    const interval = setInterval(() => {
      if (window.google?.accounts?.id) {
        clearInterval(interval);
        resolve();
      }
    }, 100);
  });

// Single-flight: initialize() + renderButton() run exactly once per mount,
// even if onMounted and a button click both call this before it resolves.
const initGoogleSSO = () => {
  if (googleSsoInit) return googleSsoInit;
  googleSsoInit = (async () => {
    await waitForGoogle();
    if (!googleSsoBtn.value) {
      googleSsoInit = null; // container not mounted yet — allow a later retry
      return;
    }
    window.google.accounts.id.initialize({
      client_id: import.meta.env.VITE_SSO_GOOGLE_CLIENT_ID,
      callback: async (response) => {
        ssoLoading.value = true;
        try {
          await userStore.ssoGoogleLogin(response.credential);
          router.replace("/");
        } catch (err) {
          toast.add({
            type: "error",
            summary: t("login.sso_error"),
            detail: getSSOErrorMessage(err),
            life: 6000,
          });
        } finally {
          ssoLoading.value = false;
        }
      },
    });
    // Render Google's own button. The user clicks it directly, launching the
    // first-party popup sign-in flow and returning an ID token
    // (response.credential) to the callback above. No One Tap prompt() is used,
    // so no deprecated display-moment methods and no FedCM warning.
    window.google.accounts.id.renderButton(googleSsoBtn.value, {
      type: "standard",
      theme: "outline",
      size: "large",
      text: "continue_with",
      width: 320,
      locale: locale.value,
    });
  })();
  return googleSsoInit;
};

const doMicrosoftSSO = async () => {
  ssoLoading.value = true;
  try {
    const idToken = await loginWithMicrosoft();
    await userStore.ssoMicrosoftLogin(idToken);
    router.replace("/");
  } catch (error) {
    toast.add({
      type: "error",
      summary: t("login.sso_error"),
      detail: getSSOErrorMessage(error),
      life: 6000,
    });
  } finally {
    ssoLoading.value = false;
  }
};

const refreshTags = async () => {
  await tagStore.fetchTags();
};

const doLogin = async () => {
  const data = {
    nome: name.value,
    login: login.value,
    password: password.value,
  };
  try {
    await userStore.login(data);

    router.replace("/");
  } catch (error) {
    console.log("LOGIN ERROR", error);
  }
};

onMounted(() => {
  fetchServerVersion();

 // Fetch não-crítico (há defaultSlide como fallback) — não deixar a rejeição flutuar.
 advertisingStore.fetchCampaigns(locale.value).catch((err) => console.error("fetchCampaigns failed", err))

  // Pre-render the hidden Google button so the popup launches on the user's
  // click without an intervening await (avoids popup blockers).
  initGoogleSSO();
});

const showLoginPage = ref(false);

onBeforeMount(() => {
  // userStore.ping().finally(() => {
  showLoginPage.value = true;
  // });
});

const stats_visible = ref(false);
</script>

<style>
/* Host for Google's officially rendered sign-in button. */
.google-sso-btn {
  display: flex;
  justify-content: center;
}
.login-page {
  background-color:#F6F1F1;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-y: auto;

  .main-section {
    flex: 1;
    display: flex;
    .banner {
      width: 60%;
    }
    .login-form {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 40%;

      .bottom-logo{
        position:absolute;
        right: 20px;
        bottom: 20px;
      }

      .logo{
        width: 70%;
        max-width: 400px;
        .logo-img{
          max-height: 50px;
        }
      }

      .form-title{
        color: red;
        width: 70%;
        max-width: 400px;
        padding: 1em 0;
        color:#787878;
        font-size: 20px;;

      }

      form {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .sso-section {
        width: 70%;
        max-width: 400px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
        margin-top: 5px;

        .sso-divider {
          width: 100%;
          display: flex;
          align-items: center;
          gap: 10px;
          color: #999;
          font-size: 13px;

          &::before, &::after {
            content: "";
            flex: 1;
            height: 1px;
            background-color: #ddd;
          }
        }

        .sso-btn {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          padding: 10px 16px;
          border: 1px solid #ddd;
          border-radius: 10px;
          background-color: white;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          transition: background-color 0.2s;

          &:hover:not(:disabled) {
            background-color: #f5f5f5;
          }

          &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
          }

          .sso-icon {
            width: 20px;
            height: 20px;
          }
        }
      }

      .field{
        width: 70%;
        max-width: 400px;
         input{
          border: none;
          display: block;
          width: 100%;
          padding: 10px;
          border-radius: 10px;
          font-weight: 500;
         }
         a{
          cursor: pointer;
          width: 100%;
          max-width: 400px;
          display: block;

          padding: 10px;
          border-radius: 10px;
          text-align: center;
         }

         &.links-container {
          display: flex;
          gap: 10px;

          a {
            flex: 1;
            width: auto;
          }
         }
      }

    }

  }
}

@media (max-width: 960px) {
  .login-page .main-section {
    flex-direction: column;
    position: relative;
  }

  .login-page .main-section .banner {
    width: 100%;
    height: 400px;
    flex-shrink: 0;
    position: relative;
    z-index: 1;
    overflow: hidden;
  }

  .login-page .main-section .login-form {
    width: 100%;
    padding: 2em 0;
    flex: 1;
    overflow-y: auto;
    position: relative;
    z-index: 2;
    background-color: #F6F1F1;
    min-height: 60vh;
  }
}


.language-dropdown-login {
  top: 0;
  right: 20px;
  margin: 1rem;
  z-index: 50;
  /* width: 100px; */

  .language-trigger-login {
    background-color: white;
    border: none;
    font-size: 200%;
    display: flex;
    align-items: center;
    padding: 0 20px;
    gap: 0.3em;
    cursor: pointer;
    border-radius: 8px;
    transition: all 0.2s ease;

    &:hover {
      background-color: #f5f5f5;
    }

    .flag {
      width: auto;
      height: auto;
      position: relative;
      top: 5px;
    }

    .chevron-icon {
      width: auto;
      height: auto;
    }
  }

  .language-menu-login {
    min-width: 150px;

    .lang-item {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-size: 0.9rem;
      font-weight: 600;
      padding: 8px 16px;

      .flag {
        position: relative;
        top: 5px;
      }

      &:hover {
        background-color: #f5f5f5;
      }
    }
  }
}

  .version-holder {
    z-index:999;
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 10px;
    color: #333 ;
    font-size: 12px;

    &.hidden {
      opacity: 0;
    }
  }

  .hash-holder {
    z-index:999;
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 10px;
    color: #333;
    font-size: 12px;

    &.hidden {
      opacity: 0;
    }
  }

</style>

<!-- <style lang="scss" scoped>
.loginPage {
  //gradient
  width: 100vw;
  height: 100vh;
  background: #f6f6f6;
  background: linear-gradient(45deg, #1e1e2d, #e84e0f);
  display: flex;
  justify-content: center;
  align-items: center;

  .login-form,
  .change-password-form {
    width: 500px;
    height: 500px;
    background-color: #fff;
    background: linear-gradient(45deg, #eb6835, #292931);
    border-radius: 10px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h2 {
      color: #1e1e2d;
      text-shadow: 1px 1px 1px rgba(255, 255, 255, 0.2);
    }

    label {
      color: white;
      font-size: 110%;
    }

    button {
      background-color: #e84e0f;
      border-color: #e84e0f;
    }

    .field {
      width: 75%;

      &.inline {
        position: relative;

        a {
          margin-left: 10px;
          position: absolute;
          display: inline-block;
          bottom: 0px;
          font-size: 80%;
          color: white;
          border-bottom: 1px solid white;
          padding-bottom: 2px;
          cursor: pointer;
          right: 0;
        }
      }
    }
  }

  .change-password-form {
    height: 600px;
  }

  .version-holder {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 10px;
    color: white;
    font-size: 12px;

    &.hidden {
      opacity: 0;
    }
  }

  .hash-holder {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 10px;
    color: white;
    font-size: 12px;

    &.hidden {
      opacity: 0;
    }
  }
}

ul.flag-list {
  padding: 0;
  margin: 0;

  li {
    list-style: none;
    cursor: pointer;
    font-size: 180%;
  }
}
</style> -->
